import { render, staticRenderFns } from "./ModalRedeem.vue?vue&type=template&id=c12d1cba&scoped=true"
import script from "./ModalRedeem.vue?vue&type=script&lang=js"
export * from "./ModalRedeem.vue?vue&type=script&lang=js"
import style0 from "./ModalRedeem.vue?vue&type=style&index=0&id=c12d1cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d1cba",
  null
  
)

export default component.exports